module.exports = __webpack_public_path__ + "static/media/mobile-beat-adobe.61f796a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bonusView/mobile-beat-adobe.svg
// module id = 480
// module chunks = 0